module.exports = __webpack_public_path__ + "static/media/resume.1fd0b4f2.pdf";